export const ADD_BASIC_INFO = 'ADD_BASIC_INFO';
export const ADD_TUNES = 'ADD_TUNES';
export const ADD_ADDITIONAL_INFORMATION = 'ADD_ADDITIONAL_INFORMATION';
export const ADD_MUSICIANS = 'ADD_MUSICIANS';
export const ADD_ADDITIONAL_DOCS = 'ADD_ADDITIONAL_DOCS' // get from api & push that to redux store